import {trackPromise} from "react-promise-tracker";
import {HIDE_MSG, SHOW_MSG} from "../types";
import languages from "../language/languages";
import {push} from "connected-react-router";
import logout from '../actions/logout';

function customFetch(serviceName,jsonValues,callback,dispatch,getState)
{
    return fetch(window.netcopkiurlid + "/rest/" +serviceName, {
        method: 'POST',
        headers: {Accept: 'application/json','Content-Type': 'application/json'},
        body: JSON.stringify(jsonValues),
        credentials: 'include'
    }).then(Response => {
        if(Response.status !== 200)
        {
            dispatch({type:SHOW_MSG,payload: {message:Response.status,type:'error'}});
            if(callback)
                callback();
            return;
        }
        return Promise.all([Response, Response.json()]).catch(reason => {
            dispatch({type:SHOW_MSG,payload: {message:reason.message,type:'error'}});
            if(callback)
                callback();
        })
    }).catch(reason => {
        console.log(reason.message);
        dispatch({type:SHOW_MSG,payload: {message:languages[getState().auth.language].serverError,type:'error'}});
        if(callback)
            callback();
    });
}

export default (serviceName,jsonValues,callback,track=true) => async (dispatch, getState) =>
{
    let toTrack=customFetch(serviceName,jsonValues,callback,dispatch,getState);
    if(track)
        toTrack=trackPromise(toTrack);
    toTrack.then(result => {
            if(result) {
                if(result[1].success)
                    dispatch({type: HIDE_MSG});
                else
                {
                    if(result[1].code === 'invalidSession')
                    {
                        dispatch(logout());
                        dispatch(push('/'));
                    }
                    let detail=result[1].detail;
                    const msg=languages[getState().auth.language][detail];
                    if(msg)
                        detail=msg;
                    dispatch({type: SHOW_MSG, payload: {message: detail,type:'error'}});
                }
            }
            if(callback)
                callback(result);
        }
    ).catch(reason => {
        dispatch({type:SHOW_MSG,payload: {message:reason.message,type:'error'}});
        if(callback)
            callback();
    });
};